import "core-js/modules/es.object.to-string.js";
var CALENDLY_SCRIPT = 'https://assets.calendly.com/assets/external/widget.js';
var CALENDLY_STYLESHEET = 'https://assets.calendly.com/assets/external/widget.css';
var CALENDLY_SCRIPT_ID = 'calendly-script';
export var CalendlyEvent = /*#__PURE__*/function (CalendlyEvent) {
  CalendlyEvent["dateSelected"] = "calendly-date-and-time-selected";
  CalendlyEvent["eventScheduled"] = "calendly-event-scheduled";
  CalendlyEvent["typeViewed"] = "calendly-event-type-viewed";
  CalendlyEvent["profilePageViewed"] = "calendly-profile-page-viewed";
  return CalendlyEvent;
}({});
export default (function (_context, inject) {
  var injectScript = function injectScript() {
    var verifyIfScriptWasInjected = function verifyIfScriptWasInjected() {
      return !!document.querySelector("#".concat(CALENDLY_SCRIPT_ID));
    };
    return new Promise(function (resolve, reject) {
      if (verifyIfScriptWasInjected()) return resolve(true);
      var calendlyScript = document.createElement('script');
      calendlyScript.setAttribute('src', CALENDLY_SCRIPT);
      calendlyScript.setAttribute('id', CALENDLY_SCRIPT_ID);
      calendlyScript.onload = function () {
        return resolve(true);
      };
      calendlyScript.onerror = reject;
      document.head.appendChild(calendlyScript);
      var calendlyLink = document.createElement('link');
      calendlyLink.setAttribute('href', CALENDLY_STYLESHEET);
      calendlyLink.setAttribute('rel', 'stylesheet');
      document.head.appendChild(calendlyLink);
    });
  };
  var open = function open(payload) {
    if (window.Calendly) {
      window.Calendly.initPopupWidget(payload);
    }
  };
  var close = function close() {
    if (window.Calendly) {
      window.Calendly.closePopupWidget();
    }
  };
  var isCalendlyEvent = function isCalendlyEvent(e) {
    return e.data.event && e.data.event.indexOf('calendly') === 0;
  };
  var registerCalendlyEventListener = function registerCalendlyEventListener(cb) {
    var listener = function listener(e) {
      if (isCalendlyEvent(e)) {
        return cb(e);
      }
    };
    window.addEventListener('message', listener);
    return function () {
      return window.removeEventListener('message', listener);
    };
  };
  inject('calendly', {
    injectScript: injectScript,
    open: open,
    close: close,
    registerCalendlyEventListener: registerCalendlyEventListener
  });
});